exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info_title[data-v-9ba0f4ce]{margin-bottom:20px;-ms-flex-wrap:wrap;flex-wrap:wrap}.info_title[data-v-9ba0f4ce],.info_title .line_box[data-v-9ba0f4ce]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.info_title .line_box[data-v-9ba0f4ce]{margin:0 35px 10px 0}.commodity_title[data-v-9ba0f4ce],.info_title .line_box .title[data-v-9ba0f4ce]{font-weight:700;color:#333}.commodity_title[data-v-9ba0f4ce]{font-size:14px;margin:30px 0 8px 0}", ""]);

// exports
